import { classNames } from '@panwds/tailwindcss';
import React, { forwardRef, useEffect, useRef } from 'react';
import { TruncateText } from '../TruncateText/index.js';
export function SubTab({ size = 'md', ...props }) {
    const buttonRef = useRef(null);
    useEffect(() => {
        if (props.hasFocus)
            buttonRef?.current?.focus();
    }, [props.hasFocus, buttonRef]);
    const buttonProps = {
        size,
        ...props,
        tabIndex: props.hasFocus ? 0 : -1
    };
    return React.createElement(Button, { ...buttonProps, ref: buttonRef });
}
const Button = forwardRef(({ id, active = false, size = 'md', children, dataMetrics, dataTestId, disabled = false, onClick, onKeyDown, tabIndex }, ref) => {
    const classes = classNames('tw-flex tw-items-center tw-px-4 tw-box-border tw-font-semibold', size === 'sm' && 'tw-text-2xs tw-h-[1.125rem] tw-px-2', size === 'md' && 'tw-text-xs tw-h-[1.375rem] tw-px-2', size === 'lg' && 'tw-text-sm tw-h-7 tw-px-3', 'hover:tw-text-primary dark:hover:tw-text-primary-dark', disabled
        ? 'tw-text-disabled dark:tw-text-disabled-dark'
        : active
            ? 'tw-text-primary dark:tw-text-primary-dark'
            : 'tw-text-hint dark:tw-text-hint-dark', 'hover:tw-bg-gray-200 dark:hover:tw-bg-gray-700', active && 'tw-bg-gray-300 dark:tw-bg-gray-800', 'tw-border-none tw-rounded', !disabled && 'tw-cursor-pointer');
    const labelText = React.createElement(TruncateText, null, children);
    return (React.createElement("button", { "data-metrics": dataMetrics, "data-testid": dataTestId || id, id: id, className: classes, role: "tab", "aria-selected": active, disabled: disabled, onClick: onClick, onKeyDown: onKeyDown, ref: ref, tabIndex: tabIndex, type: "button", style: { maxWidth: '16rem' } }, labelText));
});
Button.displayName = 'Button';
//# sourceMappingURL=SubTab.js.map